import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import notifications from './notifications'
import configurations from './configurations'
import landing from './landing'
import users from './admin/users'
import properties from './admin/properties'
import errorDashboard from './admin/error-dashboard'
import nativeAds from './admin/native-ads'
import presets from './admin/presets'
import adFormats from './admin/adFormats'
import emails from './admin/emails'
import ads from './admin/ads'
import withdraws from './admin/withdraws'
import accounts from './admin/accounts'
import targeting from './admin/targeting'
import transactions from './admin/transactions'
import bidStrategies from './admin/bid-strategies'
import displayAds from './admin/display-ads'
import languages from './admin/languages'
import scoringMultipliers from './admin/scoring-multipliers'
import languageTranslate from './admin/language-translate'
import editNativeAds from './admin/edit-native-ads'
import dashboard from './admin/dashboard'
import prebidDashboard from './admin/prebid'
import companionAd from './client/ads-manager/ads/CompanionAd'
import info from './admin/info'
import infoSectionGroup from './admin/info-section-group'
import adDebugger from './admin/ad-debugger'
import renderDebugger from './admin/render-debugger'
import configuration from './admin/configuration'
import apiKeys from './client/account/api-keys'
import industries from './admin/industries'
import dailyCosts from './admin/daily-costs'
import performanceReport from './admin/performance-report/index'
import whitelistBlackList from './admin/whitelist-blacklist'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    notifications,
    configurations,
    landing,
    users,
    properties,
    errorDashboard,
    emails,
    nativeAds,
    presets,
    adFormats,
    ads,
    withdraws,
    accounts,
    targeting,
    transactions,
    bidStrategies,
    displayAds,
    languages,
    scoringMultipliers,
    languageTranslate,
    editNativeAds,
    dashboard,
    prebidDashboard,
    companionAd,
    info,
    infoSectionGroup,
    adDebugger,
    renderDebugger,
    configuration,
    apiKeys,
    industries,
    dailyCosts,
    performanceReport,
    whitelistBlackList,
  },
  strict: process.env.DEV,
})
